import styled from "styled-components";
import { styleProps } from "../../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Finance = styled.div`
    margin-top: 30px;
    .icon-small {
        &::before {
            left: 0;
            width: auto;
            height: auto;
            font-size: 4rem;
        }
    }
`;

export const ButtonGroup = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${theme.space[4]}px;
    margin-bottom: ${theme.space[5]}px;
`;

export const Button = styled.button`
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: ${theme.space[1]}px;
    align-items: center;
    width: 100%;
    height: auto !important;
    margin: 0;
    padding: ${theme.space[2]}px !important;
    line-height: 1;
    background-color: ${theme.colors.primaryWhite} !important;
    border: 1px solid ${theme.colors.primaryBlack};
    ${styleProps};
`;

export const ButtonTextGroup = styled.div`
    display: grid;
    gap: 0.75rem;
`;

export const ButtonFlexContent = styled.div`
    display: flex;
`;

export const Details = styled.details``;

export const Summary = styled.summary`
    &::marker,
    &::-webkit-details-marker {
        display: none;
        width: 0;
        height: 0;
        content: "";
    }
`;
